import { auth } from '../clients';

/**
 * User attributes for registration
 */
export interface UserAttributes {
  phone: string[];
  passwordCreated: string[];
}

/**
 * User registration request payload
 */
export interface RegisterUserRequest {
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  attributes: UserAttributes;
}

/**
 * User registration response from API
 */
export interface RegisterUserResponse {
  id?: string;
  username?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  enabled?: boolean;
  emailVerified?: boolean;
  attributes?: UserAttributes;
  // Add more fields as needed based on actual API response
  [key: string]: unknown;
}

/**
 * Auth Service
 * Handles API calls related to user authentication and registration
 */
export const authService = {
  /**
   * Register a new user
   * @param params - User registration data
   * @returns Promise with registration response
   */
  async registerUser(
    params: RegisterUserRequest
  ): Promise<RegisterUserResponse> {
    const response = await auth.post<RegisterUserResponse>(
      '/user/register',
      params
    );
    return response.data;
  },
};

export default authService;
